import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, withStyles } from '@material-ui/core';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        minWidth: 500,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const ConfirmDialog = props => {
    const useStyles = makeStyles(theme => ({
        backDrop: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
    }));
    const { title, children, open, setOpen, onConfirm } = props;

    const classes = useStyles();
    return (
        <Dialog
            open={open}
            hideBackdrop
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="confirm-dialog">{title}</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>{children}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => setOpen(false)}
                    color="default"
                >
                    Não
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                    color="primary"
                >
                    Sim
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default ConfirmDialog;
